export const CONTACT_GUEST_CONSTANTS = {
  ROUTES: {
    MAIN: 'contact-guest',
    STATUSES: {
      ASK: 'ask',
    },
  },
};
